import * as type from "../../types/API/amyTypes";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const amyCompletionsReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.COMPLETIONS:
      return {
        ...state,
        loading: true,
      };
    case type.COMPLETIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.reply,
      };
    case type.COMPLETIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const amyReportsReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.REPORTS:
      return {
        ...state,
        loading: true,
      };
    case type.REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.REPORTS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};